import { gql } from "@apollo/client";

export const GET_DISCORD_PROFILE = gql`
  query GetDiscordProfile {
    getDiscordProfile {
      discordId
      tokens
      username
    }
  }
`;
